import axios from "axios";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const ProvidenceService = {
    list: async (filters = {}) => axios.post(`${API_DESPACHO}/providence/list`, filters).then(({data}) => data.data).catch((err) => { throw err }),
    get: async (id) => axios.get(`${API_DESPACHO}/providence/${id}`).then(({data}) => data).catch((err) => { throw err }),
    save: async (data) => axios.post(`${API_DESPACHO}/providence`, data).then(({data}) => data).catch((err) => { throw err }),
    update: async (id, data) => axios.put(`${API_DESPACHO}/providence/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(`${API_DESPACHO}/providence/${id}`).then(({data}) => data).catch((err) => { throw err }),
};

export default ProvidenceService;
